import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Box, ClickAwayListener, styled } from "@mui/material";
import clsx from "clsx";
import { useSidebarsContext } from "context/SidebarsProvider";
import InboxSidebarContainer from "../inbox/InboxSidebarContainer";
import SidebarContainer from "../../sidebars/SideBarContainer";

const SidebarContainerStyled = styled(SidebarContainer)(({ theme }) => ({
  zIndex: theme.zIndex.drawer,
  position: "absolute",
  "& .inner": {
    overflow: "auto",
    padding: "1rem",
  },
}));

const DrawerBackgroundStyled = styled("div")(({ theme }) => ({
  zIndex: theme.zIndex.drawerBackground,
  opacity: 0,
  "&.open": {
    opacity: 1,
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100vh",
    backgroundColor: "#00000088",
  },
}));

const GlobalSidebarsContainer = () => {
  const { selected, closeSidebar } = useSidebarsContext();

  const location = useLocation();

  useEffect(() => {
    if (typeof closeSidebar === "function") {
      closeSidebar();
    }
  }, [location.pathname, closeSidebar]);

  const isOpen = Boolean(selected);

  return (
    <>
      <ClickAwayListener onClickAway={closeSidebar}>
        <Box>
          <SidebarContainerStyled isOpen={isOpen} size="lg">
            {selected === "inbox" && <InboxSidebarContainer />}
          </SidebarContainerStyled>
        </Box>
      </ClickAwayListener>
      <DrawerBackgroundStyled className={clsx({ open: isOpen })} />
    </>
  );
};

export default GlobalSidebarsContainer;
